import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, catchError, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { appActions, RootState } from "../../store";

@Injectable({ providedIn: "root" })
export class ServerDownInterceptor implements HttpInterceptor {
  constructor(private readonly store: Store<RootState>) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const isApiCall = req.url.startsWith(environment.apiUrl);
        if (isApiCall && (error.status >= 500 || error.status === 0) && !req.url.includes("/health")) {
          this.store.dispatch(appActions.apiServerError());
        }
        return throwError(() => error);
      }),
    );
  }
}
